import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { ConclusionData } from '../../../../shared/types/licenses';

export const getRevisionConclusionsQueryKey = (revisionLocator: string) => ['revision-conclusions', revisionLocator];

const getRevisionConclusions = async (revisionLocator: string) => {
  return get<ConclusionData>(`/api/v2/revisions/${nuc(revisionLocator)}/correction/conclusions`);
};

/**
 * Hook to fetch revision-scoped license conclusions for a revision.
 */
export default function useGetRevisionConclusions(revisionLocator: string) {
  return useQuery({
    queryKey: getRevisionConclusionsQueryKey(revisionLocator),
    queryFn: () => getRevisionConclusions(revisionLocator),
  });
}
